import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { queryKeys } from '../lib/queryClient';
import { snakeToCamel, camelToSnake } from '../lib/utils';
import { logAction } from '../lib/actionLogger';

function mapFromDb(row) { return snakeToCamel(row); }
function mapToDb(obj) { return camelToSnake(obj); }

export function useRoster() {
  return useQuery({
    queryKey: queryKeys.roster.all,
    queryFn: async () => {
      const data = await api.get('/roster');
      return data.map(mapFromDb);
    },
  });
}

export function useAddToRoster() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (newEntry) => {
      const data = await api.post('/roster', mapToDb(newEntry));
      return mapFromDb(data);
    },
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: queryKeys.roster.all });
      logAction({
        action: 'Add Roster Member',
        details: { name: data.name, role: data.role },
      });
    },
  });
}

export function useUpdateRoster() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...updates }) => {
      const data = await api.put(`/roster/${id}`, mapToDb(updates));
      return mapFromDb(data);
    },
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: queryKeys.roster.all });
      logAction({
        action: 'Update Roster Member',
        details: { name: data.name, role: data.role },
      });
    },
  });
}

export function useRemoveFromRoster() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (entryId) => {
      await api.del(`/roster/${entryId}`);
    },
    onSuccess: (_data, entryId) => {
      qc.invalidateQueries({ queryKey: queryKeys.roster.all });
      logAction({
        action: 'Remove Roster Member',
        details: { entryId },
      });
    },
  });
}
